export default "__VITE_ASSET__DLfyTvUq__"